import { FileImage, Stamp, TriangleAlert } from "lucide-react";
import { defineFeature } from "../types";

/**
 * Approvals — creative proofing, staff side (PRD §8 Item 11, US-11.2 … US-11.7).
 *
 * `/proofs/:id` is fixed by ENTITY_ROUTES for the `deliverable` entity: the
 * API links there from approval notifications, search results and e-mails, so
 * this feature must serve it. The client's half of the same screen lives in
 * the portal and on the no-login link, and draws the artwork with the same
 * shared canvas (`components/proof/proof-canvas`).
 */
export default defineFeature({
  key: "proofs",
  title: "Approvals",
  entities: ["deliverable"],
  routes: [
    { path: "proofs", lazy: () => import("./page") },
    { path: "proofs/:id", lazy: () => import("./detail") },
  ],
  nav: [
    {
      label: "Approvals",
      to: "/proofs",
      icon: Stamp,
      group: "delivery",
      order: 42,
      permission: "projects:read",
      description: "Creative the client has to sign off",
    },
  ],
  quickCreate: [
    {
      key: "proof",
      label: "Proof for approval",
      icon: FileImage,
      to: "/proofs?new=1",
      permission: "projects:write",
      description: "Upload artwork the client signs off",
    },
  ],
  commands: [
    { key: "proofs.board", label: "Approvals board", icon: Stamp, to: "/proofs", group: "navigate", permission: "projects:read", keywords: ["proof", "creative", "sign off", "review"] },
    {
      key: "proofs.rounds",
      label: "Out-of-scope revision rounds",
      icon: TriangleAlert,
      to: "/proofs?tab=rounds",
      group: "actions",
      permission: "projects:read",
      keywords: ["scope creep", "extra rounds", "change fee"],
    },
  ],
});
